import { render, staticRenderFns } from "./CommentPost.vue?vue&type=template&id=76445bc4&scoped=true"
import script from "./CommentPost.vue?vue&type=script&lang=js"
export * from "./CommentPost.vue?vue&type=script&lang=js"
import style0 from "./CommentPost.vue?vue&type=style&index=0&id=76445bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76445bc4",
  null
  
)

export default component.exports